import Clarity from "@microsoft/clarity";
import Mixpanel from "mixpanel-browser";
import { LocalStorageUtils } from "../utils/localstorage.utils.jsx";
import posthog from "posthog-js";

export default class AnalyticsService {
  static init() {
    MsClarityAnalyticsService.init();
    MixpanelAnalyticsService.init();
  }

  static identifyUser() {
    const userId = LocalStorageUtils.getUserId();
    MsClarityAnalyticsService.identifyUser(userId);
    MixpanelAnalyticsService.identifyUser(userId);
    PostHogAnalyticsService.identifyUser(userId);
  }

  static trackEvent(eventName, properties = {}) {
    MsClarityAnalyticsService.trackEvent(eventName);
    MixpanelAnalyticsService.trackEvent(eventName, properties);
    PostHogAnalyticsService.trackEvent(eventName, properties);
  }

  static recordSession(reason) {
    MsClarityAnalyticsService.recordSession(reason);
  }

  static setTag(key, value) {
    if (key && value) {
      MsClarityAnalyticsService.setTag(key, value);
      MixpanelAnalyticsService.setSuperProperties({
        [key]: value,
      });
      PostHogAnalyticsService.setSuperProperties({
        [key]: value,
      });
    }
  }
}

class MsClarityAnalyticsService {
  static isInitialized = false;
  static init() {
    const clarityToken = process.env.REACT_APP_MICROSOFT_CLARITY_ID;
    if (clarityToken) {
      Clarity.init(clarityToken);
      this.isInitialized = true;
    }
  }

  static identifyUser(userId) {
    if (!this.isInitialized) {
      return;
    }
    if (userId) {
      Clarity.identify(userId);
    }
  }

  static trackEvent(eventName) {
    if (!this.isInitialized) {
      return;
    }
    Clarity.event(eventName);
  }

  static recordSession(reason) {
    if (!this.isInitialized) {
      return;
    }
    Clarity.upgrade(reason);
  }

  static setTag(key, value) {
    if (!this.isInitialized) {
      return;
    }
    Clarity.setTag(key, value);
  }
}

class MixpanelAnalyticsService {
  static isInitialized = false;
  static init() {
    const mixpanelToken = process.env.REACT_APP_MIXPANEL_TOKEN;
    if (mixpanelToken) {
      Mixpanel.init(mixpanelToken, {
        autocapture: true,

        record_sessions_percent: 1,
        record_heatmap_data: true,
      });
      this.isInitialized = true;
    }
  }

  static identifyUser(userId) {
    if (!this.isInitialized) {
      return;
    }
    if (userId) {
      Mixpanel.identify(userId);
    }
  }

  static trackEvent(eventName, properties = {}) {
    if (!this.isInitialized) {
      return;
    }
    Mixpanel.track(eventName, properties);
  }

  static setSuperProperties(properties) {
    if (!this.isInitialized) {
      return;
    }
    Mixpanel.register(properties);
  }
}

class PostHogAnalyticsService {
  static identifyUser(userId) {
    posthog.identify(userId);
  }

  static trackEvent(eventName, properties = {}) {
    posthog.capture(eventName, properties);
  }

  static setSuperProperties(properties) {
    posthog.capture("$set", {
      $set: properties,
    });
  }
}
